import postscribe from 'postscribe'
import 'whatwg-fetch'
// import AnalyticsService from './AnalyticsService'
import config from 'src/config/wechat'
// import i18n from 'src/i18n'
import 'url-search-params-polyfill'

// BASE
let base = __dirname
// const assetsPublicPath = require('src/../config').build.assetsPublicPath
// if (process.env.NODE_ENV === 'production') {
//   base = assetsPublicPath
// }

// SHARE IMAGE
const shareImg = '/share.png'

// WECHAT SERVICE
class WechatService {
  constructor() {
    this.lastUrl = null
    this.injected = false
    this.isWechat = /micromessenger/i.test(navigator.userAgent)
    this.debugEnabled = new window.URLSearchParams(window.location.search).get('_wechatDebug') !== null
  }

  async init() {
    if (this.isWechat) {
      await this.injectScript()
    }
  }

  async load() {
    await this.updateConfig()
    await this.enableShare()
    await this.setDefaultLink()
  }

  injectScript() {
    return new Promise((resolve) => {
      if (this.injected) {
        resolve()
        return
      }
      this.injected = true

      if (!this.isWechat) {
        resolve()
        return
      }

      // document.addEventListener('WeixinJSBridgeReady', resolve)
      if (typeof window.WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
        resolve()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', resolve, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', resolve)
          document.attachEvent('onWeixinJSBridgeReady', resolve)
        }
      }

      const head = document.head || document.getElementsByTagName('head')[0]
      const src = '//res.wx.qq.com/open/js/jweixin-1.2.0.js'
      postscribe(head, `<script src='${src}'></script>`)
    })
  }

  updateConfig = () => {
    return new Promise((resolve) => {
      if (!this.isWechat) {
        resolve()
        return
      }

      let configUrl = `${config.api}`

      if (this.lastUrl === encodeURIComponent(window.location.href.split('#')[0])) {
        resolve()
        return
      }

      this.lastUrl = encodeURIComponent(window.location.href.split('#')[0])

      const requestUrl = `${configUrl}?link=${this.lastUrl}`

      window
        .fetch(requestUrl)
        .then((response) => {
          return response.json()
        })
        .then((json) => {
          return this.handleConfigSuccess(json)
        })
        .then(() => {
          resolve()
        })
    })
  }

  handleConfigSuccess = (config) => {
    return new Promise((resolve) => {
      if (!window.wx) return resolve()

      window.wx.config({
        debug: this.debugEnabled,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems'],
      })

      console.log({
        debug: this.debugEnabled,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems'],
      })

      window.wx.ready(() => {
        resolve()
      })
    })
  }

  enableShare = () => {
    // console.log('enableShare')
    return new Promise((resolve) => {
      if (!this.isWechat) {
        resolve()
        return
      }

      window.wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook'],
      })
      resolve()
    })
  }

  disableShare = () => {
    // if (!window.wx) return
    window.wx.hideMenuItems({
      menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook'],
    })
  }

  setLink = (path, title = '', desc = '', moments = '', shareImg) => {
    const base = window.location.origin
    const link = `${base}${path}`
    const img = `${base}${shareImg}`

    if (!this.isWechat) {
      return
    }

    window.wx.onMenuShareTimeline({
      link: link,
      title: moments,
      imgUrl: img,
      success: () => {
        // AnalyticsService.sendEvent('share', 'onMenuShareTimeline')
      },
    })

    window.wx.onMenuShareAppMessage({
      link: link,
      title: title,
      desc: desc,
      imgUrl: img,
      success: () => {
        // AnalyticsService.sendEvent('share', 'onMenuShareAppMessage')
      },
    })
  }

  setDefaultLink = () => {
    return this.setLink(`${base}`, config.generic.title, config.generic.desc, config.generic.moments, shareImg)
  }
}

export default new WechatService()
